import { render } from "./OJTAssessment.vue?vue&type=template&id=19d29de1"
import script from "./OJTAssessment.vue?vue&type=script&lang=js"
export * from "./OJTAssessment.vue?vue&type=script&lang=js"

import "./OJTAssessment.vue?vue&type=style&index=0&id=19d29de1&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__